module.exports = __webpack_public_path__ + "img/CLOAK.d790e5b7.svg";